<div class="header-bar">
  <div class="header-left">
    <div class="header-text">User Groups</div>
    <div class="divider"></div>
    <div class="search-box input-box">
      <svg-icon src="assets/svg/magnifier.svg"></svg-icon>

      <mat-form-field>
        <input
          matInput
          (keyup)="applyFilter()"
          matInput
          type="text"
          [(ngModel)]="searchValue"
        />
      </mat-form-field>
    </div>
    <div class="divider"></div>
    <div class="filter">
      <button mat-button class="icon-btn" (click)="toggleFilterDialog()">
        <svg-icon src="assets/svg/filter.svg" svgClass="grey"></svg-icon>
      </button>
    </div>
  </div>
  <div class="header-center"></div>
  <div class="header-right">
    <button mat-button color="lightGreen" (click)="createNewGroup()">
      Create New Group
    </button>
  </div>
</div>

<div class="groups-list">
  <div class="container groups-container">
    <div class="container-header no-bottom-border">
      <div class="text">Existing Groups</div>
      <div class="options">
        <button mat-icon-button [matMenuTriggerFor]="groupsMenu">
          <svg-icon src="assets/svg/ellipsis.svg"></svg-icon>
        </button>
        <mat-menu class="mat-menu-elaphant vertical-menu" #groupsMenu="matMenu">
          <button
            class="icon-btn-w-text"
            mat-menu-item
            (click)="createNewGroup()"
          >
            <svg-icon src="assets/svg/plus-circle-white.svg"></svg-icon>
            <span>Create Group</span>
          </button>
        </mat-menu>
      </div>
    </div>

    <div class="container-content">
      <table #groupsTable mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Group Name</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.name">
              {{ row.name }}
            </ng-container>
            <ng-container *ngIf="!row.name"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="members">
          <th mat-header-cell *matHeaderCellDef mat-sort-header># Members</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.members">
              {{ row.members }}
            </ng-container>
            <ng-container *ngIf="!row.members"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Creation Date
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.created_at">
              {{ formatDate(row.created_at) }}
            </ng-container>

            <ng-container *ngIf="!row.created_at"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="created_by_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created By</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.created_by_name">
              {{ row.created_by_name }}
            </ng-container>
            <ng-container *ngIf="!row.created_by_name"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="modified_at">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>
            Last Modified
          </th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.modified_at">
              {{ formatDate(row.modified_at) }}
            </ng-container>

            <ng-container *ngIf="!row.modified_at"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="modified_by_name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Modified By</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.modified_by_name">
              {{ row.modified_by_name }}
            </ng-container>
            <ng-container *ngIf="!row.modified_by_name"> - </ng-container>
          </td>
        </ng-container>

        <ng-container matColumnDef="options">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="options-cell">
            <button mat-button (click)="copy(row)" class="icon-btn">
              <svg-icon
                src="assets/svg/copy.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <button mat-button (click)="edit(row)" class="icon-btn">
              <svg-icon
                src="assets/svg/pencil.svg"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <!-- <div  class="empty-btn-space"></div> -->
            <button class="icon-btn" mat-button (click)="delete(row)">
              <svg-icon
                src="assets/svg/trashcan.svg"
                [svgStyle]="{
                  'width.px': '15.25',
                  'height.px': '16.204'
                }"
                svgClass="lightBlue"
              ></svg-icon>
            </button>
            <!-- <div
                class="empty-btn-space"
              ></div> -->
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      <mat-paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="perPage"
      (page)="onPageChange($event)"></mat-paginator>
    </div>
  </div>
</div>
